module.exports = __webpack_public_path__ + "img/CHEDRAUI_MOBILE.ac1a3365.png";